module.exports = __webpack_public_path__ + "img/image015.33399aec.png";